<template>
    <el-container class="list-page">
        <el-header class="list-page-header">
            <h1 class="list-page-title">{{$t('item.pageTitle')}}</h1>
            <div class="list-page-search">
                <el-input prefix-icon="el-icon-search" v-model="searchContent" :placeholder="$t('item.searchPlaceholder')"></el-input>
            </div>
            <el-button class="list-page-add-button" type="primary" @click.native.prevent="goAddItem">
                <i class="el-icon-plus"></i>
                <span>{{$t('item.addItem')}}</span>
            </el-button>
        </el-header>
        <el-main class="list-page-main">
            <template>
                <div class="list-table-card">
                    <el-table class="list-table" v-loading="loading" @sort-change="sortTable" :data="tableData" @row-click='handleRowHandle'>
                        <el-table-column v-if="userSetting.isShowProduceCode === 1" prop="itemCode" :label="userSetting.codeLabel" min-width="160"></el-table-column>
                        <el-table-column prop="itemDescription" :label="userSetting.descriptionLabel" sortable="custom" :sort-orders="['descending', 'ascending']" min-width="320">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'itemDescription'}">
                                    {{userSetting.descriptionLabel}}
                                    <svg v-if="orderName === 'itemDescription'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'itemDescription' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                            <template slot-scope="scope">
                                <span class="list-description-cell">{{scope.row.itemDescription}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rate" :formatter="amountFormat" :label="userSetting.rateLabel" min-width="140" align="right" header-align="right"></el-table-column>
                        <el-table-column prop="inventoryNumber" :label="$t('item.columnInventoryCountUnit')" min-width="150" align="right" header-align="right">
                            <template slot-scope="scope">
                                <span>{{scope.row.inventoryNumber}}</span>
                                <span v-if="scope.row.unit"> {{scope.row.unit}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="list-pagination">
                    <el-pagination
                            @size-change="changeTotalCount"
                            @current-change="changePage"
                            :current-page="currentPage"
                            :page-sizes="[50, 100, 200, 400]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                    </el-pagination>
                </div>
            </template>
        </el-main>
    </el-container>
</template>

<script>
    import {debounce} from '@/utils/debounce'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {readListPagination, writeListPagination} from '@/utils/listPagination'

    export default {
        methods: {
            restoreListPagination() {
                const pagination = readListPagination('item');
                if (pagination != null) {
                    this.currentPage = pagination.currentPage;
                    this.pageSize = pagination.pageSize;
                }
            },
            saveListPagination() {
                writeListPagination('item', this.currentPage, this.pageSize);
            },
            goAddItem() {
                let self = this;
                self.$router.push('/itemCreate');
            },
            queryList() {
                this.loading = true;
                let that = this;
                this.$axios.post('query_item_list_user_web', {
                    params: {
                        "currentPage": that.currentPage,
                        "pageSize": that.pageSize,
                        "userWebCommonQuery": that.searchContent,
                        "orderName": that.orderName,
                        "orderTpe": that.orderTpe,
                        "delStatus": 0
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        that.tableData = response.data.dataList;
                        that.totalCount = response.data.totalCount;
                        that.userSetting = JSON.parse(localStorage.getItem('userSetting')) || {};
                    }
                    this.loading = false;
                })
            },

            sortTable(column) {
                if (!column.order) {
                    this.orderName = "";
                    this.orderTpe = "";
                    this.queryList();
                    return;
                }
                this.orderName = column.prop;
                if (column.order === "ascending") {
                    this.orderTpe = 1
                } else if (column.order === "descending") {
                    this.orderTpe = 2
                }
                this.queryList();
            },
            changePage(val) {
                this.currentPage = val;
                this.saveListPagination();
                this.queryList();
            },
            changeTotalCount(val) {
                this.pageSize = val;
                this.saveListPagination();
                this.queryList();
            },
            handleRowHandle(row, event, column) {
                //点击每一条列表数据触发的方法
                if (column.className === "el-table-column--selection") {
                    return false;
                } else {
                    //因为需要考虑详情里面的刷新 所以把拿过去的信息放在缓存里面
                    this.$router.push({path: 'itemUpdate', query: {innerUUID: row.innerUUID}});
                }
            },
            //金钱格式化,增加金钱符号和分隔符
            amountFormat: function (row, column) {
                var columnAmount = row[column.property];
                if (columnAmount == undefined) {
                    return "";
                }
                return xiaoshudianfenge(columnAmount, this.userSetting);
            }
        },
        data() {
            return {
                tableData: [],
                loading: true,
                currentPage: 1,
                totalCount: 0,
                pageSize: 50,
                searchContent: "",
                orderName: "createDate",
                orderTpe: 2,
                userSetting: {}
            }
        },
        mounted() {
            this.restoreListPagination();
            this.queryList();
            this.$watch('searchContent', debounce(() => {
                this.queryList();
            }, 500))
        }
    }
</script>
